/* eslint-disable array-bracket-newline */
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import { Network } from '@kattana-io/common';
import { useState } from 'react';

export interface NetworkSelectorCoreProps {
  textSize: 16 | 14;
  textWeight: '400' | '500' | '600';
  imageSize: 'l' | 'm';
  currentNetwork: Network;
  onClickCallback: (networkId: number) => void;
  loading?: boolean;
}

export const enabledNetworks = [
  1, 56, 137, 43114, 250, 10, 42161, 999999, 25, 324, 7700, 99999999, 100,
  1666600000, 1284, 369, 199, 66, 8453, 999998, 1313161554, 82, 10242, 2222,
  169, 1088, 1030, 59144, 1399811149,
];
export const enabledNetworksWithData = [
  1, 56, 66, 137, 250, 43114, 7700, 999999, 99999999, 369, 10242,
];
export const enabledTestnetNetworks = [97, 10243, 421614];
export const enabledNetworksWithWalletData = [1, 56, 137, 43114, 42161, 999999];

export const networks = enabledNetworks.map((chainId) =>
  Network.fromChainId(chainId)
);

export const testnetNetworks = enabledTestnetNetworks.map((chainId) =>
  Network.fromChainId(chainId)
);

export const networksBySym = [...networks, ...testnetNetworks].reduce<
  Record<string, Network | undefined>
>((cons, item) => ({ ...cons, [item.getSymbol()]: item }), {});

export const networksWithData = enabledNetworksWithData.map((chainId) =>
  Network.fromChainId(chainId)
);

export const networksWithWalletData = enabledNetworksWithWalletData.map(
  (chainId) => Network.fromChainId(chainId)
);

export const NetworkSelectorCore = ({
  textSize,
  textWeight,
  imageSize,
  currentNetwork,
  onClickCallback,
  loading,
}: NetworkSelectorCoreProps) => {
  const [isOptionMenuVisible, setVisible] = useState(false);

  // Solana cannot be used and added in crypto wallet yet
  const networkSelectorItems = networks.filter((item) => !item.isSOLANA());

  const onClick = (e: any, id: number) => {
    e.stopPropagation();
    onClickCallback(id);
    setVisible(false);
  };

  return (
    <div className='network_selector'>
      {loading ? (
        <Text
          size={textSize}
          className={`text--grey-400 text--weight-${textWeight}`}
        >
          Switching...
        </Text>
      ) : (
        <div
          className='network_selector__selected'
          onClick={() => setVisible(!isOptionMenuVisible)}
        >
          {currentNetwork && (
            <Image
              src={currentNetwork.getImage()}
              size={imageSize}
              className={`network_selector--${currentNetwork.chain}`}
            />
          )}
          {currentNetwork ? (
            <Text
              size={textSize}
              className={`text--grey-200 text--weight-${textWeight}`}
            >
              {currentNetwork.getTitle()}
            </Text>
          ) : (
            <Text
              size={textSize}
              className={`text--grey-200 text--weight-${textWeight}`}
            >
              Unknown
            </Text>
          )}
        </div>
      )}

      {isOptionMenuVisible && (
        <>
          <div
            className='network_selector__backdrop'
            onClick={() => setVisible(false)}
          />
          <div className='network_selector__background'>
            <div className='network_selector__optionsMenu'>
              {networkSelectorItems.map((item) => {
                if (!item) {
                  return;
                }

                return (
                  <div
                    key={item.chain}
                    onClick={(e) => onClick(e, item.toDecimal())}
                    className={`network_selector__optionsMenu__item ${
                      item.toDecimal() === currentNetwork?.toDecimal()
                        ? 'network_selector__optionsMenu__item--active'
                        : ''
                    }`}
                  >
                    <Image
                      src={item.getImage()}
                      size={imageSize}
                      className={`network_selector--${item.chain}`}
                    />
                    <Text
                      size={textSize}
                      className={`text--grey-400 text--weight-${textWeight}`}
                    >
                      {item.getTitle()}
                    </Text>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NetworkSelectorCore;
